import { viewSelectStyles } from "@bevco/Overrides/Widgets/ProductList/ProductListTableViewFilter";
import { css } from "styled-components";

viewSelectStyles.wrapper = {
    ...viewSelectStyles.wrapper,
    css: css`
        display: flex;
        padding-top: 0;
        justify-content: flex-end;
    `,
};

viewSelectStyles.filterButton = {
    variant: "secondary",
    sizeVariant: "medium",
    css: css`
        width: 100%;
    `,
};
